
export class UploadFile {
    url: string;
    size: number;
    name: string;
    type: string;
    file: any;
    uploadedDate: any;
    id: number;
    createBy: any;

    constructor(params: any = {}, isParsingFromRespond: boolean = true) {
        if (isParsingFromRespond) {
            this.parseFromResp(params);
        } else {
            this.id = params.id;
            this.name = params.name;
            this.file = params;
            this.type = this.getType(params.name);
        }
    }

    getType(type: string) {
        const array = type.split('.');
        return array[array.length - 1];
    }

    getName(fileUrl: string) {
        const index = fileUrl.lastIndexOf('/');
        return fileUrl.slice(index +  1, fileUrl.length);
    }

    parseFromResp(fileUrl) {
        this.type = this.getType(fileUrl);
        const startIndex = fileUrl.indexOf('/download/file');
        // this.url = API_URL.FILE_URL + fileUrl.slice(startIndex, fileUrl.length);
        this.name = this.getName(fileUrl);
    }

    convertToReqBody() {
        return this.url;
    }

    setUrl(url: string) {
        return this.url = url;
    }
}

